import { ActionContext } from 'vuex';

import links from '@/app/shared/state/links';
import request from '@/app/shared/state/request';

import constants from '@/common/constants';

import { NSI_ACTIONS_NAME, NSI_MUTATIONS_NAME } from './name';
import { TNsiState } from './types';

export async function getNsiCountryWithData(context: ActionContext<TNsiState, unknown>) {
  if (!context.state?.nsiCountryListWithData?.length) {
    return await request.call(
      null,
      context,
      {
        url: links.nsi.nsiCountryWithData,
        mutate: NSI_MUTATIONS_NAME.setNsiCountryWithData,
        name: NSI_ACTIONS_NAME.getNsiCountryWithData,
      },
      {
        pageNumber: 1,
        pageSize: 0,
        isTemplate: true,
      },
    );
  }
}

export async function getNsiBusinessTipsStatus(context: ActionContext<TNsiState, unknown>) {
  if (!context.state?.nsiBusinessTipsStatusList.length) {
    return await request.call(
      null,
      context,
      {
        url: links.nsi.nsiMpkBusinessStatus,
        mutate: NSI_MUTATIONS_NAME.setNsiBusinessTipsStatusList,
        name: NSI_ACTIONS_NAME.getNsiBusinessTipsStatus,
      },
      {
        ...constants.paramsFullListDefault,
      },
    );
  }
}
